
/*
 * Copyright (C) 2015 ICOS Group, Newcastle University.  All rights reserved.
 * Contact:  James Alastair McLaughlin <j.a.mclaughlin@ncl.ac.uk>
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 *  
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS ``AS IS'' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 */

"use strict";

var URI = require('urijs'),
    Identified = require('./Identified'),
    util = require('./util');

/**
 * Class to represent an SBOL2 Interaction.
 */
class Interaction extends Identified
{
    constructor(sbolDocument, uri) {

        super(sbolDocument, uri);

        this._types = [];
        this._participations = [];
        this._measures = [];
    }

    /**
     * Add a type to this Interaction.
     * @param {string|URI} [type]
     */
    addType(type) {
        this._types.push(util.uriOrObject(type));
    }

    /**
     * Retrieve a list of types for this Interaction.
     * @returns {URI[]} [types]
     */
    get types() {
        return this._types;
    }
    
    /**
     * Add a Participation to this Interaction.
     * @param {string|URI|Paticipation} [participation]
     */
    addParticipation(participation) {
        this._participations.push(util.uriOrObject(participation));
    }

    /**
     * Retrieve the list of Participations for this Interaction.
     * There may be URIs present in this list if the participation(s) have not
     * yet been resolved.
     *
     * @returns {Participation[]}
     */
    get participations() {
        return this._participations;
    }

    /**
     * Retrieve the list of measures assigned to this Interaction.  There may be
     * URIs present in this list if the measures(s) have not yet been resolved.
     *
     * @returns {Measure[]}
     */
    get measures() {
        return this._measures.slice(0);
    }

    /**
     * Add a Measure to this Interaction.
     * @param {string|URI|Measure} [measure]
     */
    addMeasure(measure) {
        this._measures.push(util.uriOrObject(measure));
    }

    /**
     * Attempt to resolve participations by URI.
     */
    link() {
        this._participations = this._sbolDocument.lookupURIs(this._participations);
        this._measures = this._sbolDocument.lookupURIs(this._measures);
    }
}

module.exports = Interaction;

